import RecapReportTests from './RecapReportTests';

export default RecapReportTests;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/RecapReport/RecapReportTests/index.tsx